import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({})
export default class ReadBottom extends Vue {
  //
  // ────────────────────────────────────────────────── I ──────────
  //   :::::: P R O P S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────
  //

  @Prop({ type: Object }) item!: mail.EmailMessage

  //
  // ────────────────────────────────────────────────────── I ──────────
  //   :::::: M E T H O D S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────
  //

  route(type: 're' | 'reall' | 'fw') {
    const item = this.item
    const allowedActions = (item.actions || '').split(', ')
    const ensureAction = async (action: string) => {
      if (!allowedActions.includes(action)) {
        switch (action) {
            case 'Reply':
                await(window as any).alertAsync(this.$t('M_Email_NotAllowedActionReply').toString())
                break;

            case 'ReplyAll':
                await(window as any).alertAsync(this.$t('M_Email_NotAllowedActionReplyAll').toString())
                break;

            case 'Forward':
              await(window as any).alertAsync(this.$t('M_Email_NotAllowedActionForward').toString())
              break;
        }
        throw new Error('NOT_ALLOWED_ACTION')
      }
    }
    switch (type) {
      case 're':
        ensureAction('Reply')
      case 'reall':
        ensureAction('ReplyAll')
      case 'fw':
        ensureAction('Forward')
        this.$router.push({
          name: 'mail-write',
          query: { id: item.id, type },
        })
        break
    }
  }
}
